import { useEffect } from "react";
import { f7 } from "framework7-react";
import Dashboard from "./modules/Dashboard/Dashboard";
import AboutPage from "./modules/static-pages/AboutPage";
import AuthPage from "./modules/auth/AuthPage";
import {QuickbetList} from "./modules/Composer/Quickbet/Containers/QuickbetList";
import {Profile} from "./modules/Profile/Profile";
import {Promotion} from "./modules/Promotion/Promotion";
import {Tickets} from "./modules/Composer/Tickets/Tickets";
import Error404 from "./modules/Errors/Error404";
import { isUserAuthenticated } from "./modules/auth/authHelper";

const HomePageWithAuthCheck = () => {
    const isAuth = isUserAuthenticated();
    useEffect(() => {
        if (!isAuth) {
            f7.views.main.router.navigate("/auth/");
        }
    }, [isAuth]);
    return<Dashboard />;
};

const routes = [
    {
        path: "/",
        component: HomePageWithAuthCheck,
    },
    {
        path: "/about/",
        component: AboutPage,
    },
    {
        path: "/profile/",
        component: Profile,
    },
    {
        path: "/auth/",
        component: AuthPage,
    },
    {
        path: "/promote/",
        component: Promotion,
    },
    {
        path: "/tickets/",
        component: Tickets,
        options: {
            transition: "f7-push"
        }
    },
    {
        path: "/quickbet/",
        component: QuickbetList,
    },
    {
        path: "(.*)",
        component: Error404,
    },
];

export default routes;
